export default __webpack_public_path__ + "static/media/web_left.3d9b3b40.png";